const items = [
  {
    link: 'home',
    text: 'Home',
  },
  {
    link: 'about',
    text: 'About',
  },
  {
    link: 'skills',
    text: 'Skills',
  },
  {
    link: 'projects',
    text: 'Projects',
  },
  {
    link: 'contact',
    text: 'Contact',
  },
];

export default items;
